export default __webpack_public_path__ + "static/6-backup-3a21faa02019c057837ba941ec255b96.jpg";